import io from "socket.io-client";
import config from "../config";

// Internal reference count so multiple components can call `connect()` and
// `disconnect()` safely without tearing down the shared connection while
// another component still needs it.
let _connectRefCount = 0;

const createSocket = () => {
	const s = io(config.api.socketUrl, {
		transports: ["websocket"],
		// Don't auto connect: components call `connect()` explicitly and we
		// manage the lifecycle with the ref count.
		autoConnect: false,
	});

	const originalConnect = s.connect && s.connect.bind(s);
	const originalDisconnect = s.disconnect && s.disconnect.bind(s);

	s.connect = function () {
		_connectRefCount++;
		if (_connectRefCount === 1 && typeof originalConnect === "function") {
			try {
				originalConnect();
			} catch (err) {
				console.log("web-socket: connect error", err);
			}
		}
		return s;
	};

	s.disconnect = function () {
		_connectRefCount--;
		if (_connectRefCount <= 0) {
			_connectRefCount = 0;
			if (typeof originalDisconnect === "function") {
				try {
					originalDisconnect();
				} catch (err) {
					console.log("web-socket: disconnect error", err);
				}
			}
		}
		return s;
	};

	return s;
};

// Shared socket instance — keep the exported name `socket` for backwards
// compatibility with modules that import it directly.
export const socket = createSocket();

// Return the shared socket instance.
export const getSocket = () => socket;

// Backwards-compatible emitter that uses the shared socket.
export const emitWebSocket = (type, data) => {
	if (!socket) return;
	socket.emit(type, data);
};
